"use client";

import { ProductPage } from "app/[locale]/product/[input]/ProductPage";
import { ProductPageV2 } from "app/[locale]/product/[input]/ProductPageV2";
import { useRegisterPageView } from "containers/GoogleAnalytics/googleAnalyticsEvents";
import { useEntityConfigurationValueByKey } from "hooks/useEntityConfiguration";
import { useEffect } from "react";

import { ProductQuery } from "@holibob-packages/ui-core/gql-request";

type ProductPageWrapperProps = {
    product: ProductQuery["product"];
};

export const ProductPageWrapper = ({ product }: ProductPageWrapperProps) => {
    useRegisterPageView("Product", product.name, product.id);

    //TODO Remove after upgrading to next@13.4.19
    useEffect(() => window.scrollTo({ top: 0 }), []);

    const withWhiteLabelDesignV2 = useEntityConfigurationValueByKey("SETTING.WHITE_LABEL_DESIGN_V2") ?? false;
    return withWhiteLabelDesignV2 ? <ProductPageV2 product={product} /> : <ProductPage product={product} />;
};
